<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body-form">
              <el-form :model="item">
                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>问答名称 <span style="color: red">*</span></label>
                      <div class="title-limit-desc">
                        <input
                          v-model="item.title"
                          type="text"
                          class="form-control"
                          maxlength="200"
                          placeholder="请输入名称"
                        />
                        <span class="number-of-word"
                          >{{ item.title.length }}/200</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 封面 -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label>封面图 <span style="color: red">*</span></label>
                      <!-- 内容详情页面 -->
                      <div>
                        <image-upload size="16:9" ref="coverImg"></image-upload>
                      </div>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 16:9，建议尺寸 1500 * 840 px，最好不要超过1M
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 欢迎图 背景 結束 -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label>欢迎图</label>
                      <!-- 内容详情页面 -->
                      <div>
                        <image-upload
                          size="9:19.5"
                          ref="welComeImg"
                        ></image-upload>
                      </div>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 9:19.5，建议尺寸
                        1242x2688（安全高度2208）px，最好不要超过5M
                      </div>
                    </div>
                    <div class="mb-3">
                      <label>背景图</label>
                      <div>
                        <image-upload size="9:19.5" ref="BgImg"></image-upload>
                      </div>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 9:19.5，建议尺寸
                        1242x2688（安全高度2208）px，最好不要超过5M
                      </div>
                    </div>
                    <div class="mb-3">
                      <label>结束图 <span style="color: red">*</span></label>
                      <div>
                        <image-upload size="8:5" ref="endImg"></image-upload>
                      </div>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 8:5，建议尺寸1242x780 px，最好不要超过5M
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label>主题色</label>
                      <div class="flex">
                        <el-input
                          class="m-r-20"
                          clearable
                          v-model="item.subjectColor"
                          style="width: 140px"
                        ></el-input>
                        <el-color-picker
                          v-model="item.subjectColor"
                        ></el-color-picker>
                      </div>

                      <!-- <t-color-picker
                        :clearable="true"
                        format="HEX"
                        :colorModes="colorArr"
                        v-model="item.subjectColor"
                      /> -->
                    </div>
                    <div class="mb-3">
                      <label>辅助色</label>
                      <div class="flex">
                        <el-input
                          class="m-r-20"
                          clearable
                          v-model="item.auxiliaryColor"
                          style="width: 140px"
                        ></el-input>
                        <el-color-picker
                          v-model="item.auxiliaryColor"
                        ></el-color-picker>
                      </div>
                      <!-- <t-color-picker
                        :clearable="true"
                        format="HEX"
                        :colorModes="colorArr"
                        v-model="item.auxiliaryColor"
                      /> -->
                    </div>
                  </div>
                </div>

                <!-- <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label>背景图</label>
                      <div>
                        <image-upload size="9:19.5" ref="BgImg"></image-upload>
                      </div>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 9:19.5，建议尺寸
                        1242x2688（安全高度2208）px，最好不要超过5M
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label>结束图</label>
                      <div>
                        <image-upload size="8:5" ref="endImg"></image-upload>
                      </div>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 8:5，建议尺寸1242x780 px，最好不要超过5M
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>答题时间 <span style="color: red">*</span></label>
                      <span class="flex" style="align-items: center">
                        <el-input
                          min="0"
                          max="300"
                          type="number"
                          @input="qaMinutesChange($event, 300)"
                          @change="qaMinutesChange($event, 300)"
                          style="width: 80px"
                          v-model.number="qaMinutes"
                        />

                        <span style="margin: 0 10px">分</span>
                        <el-input
                          min="0"
                          max="60"
                          @input="qaSecondsChange($event, 59)"
                          @change="qaSecondsChange($event, 59)"
                          style="width: 80px"
                          v-model.number="qaSeconds"
                          type="number"
                        />
                        <span style="margin: 0 10px">秒</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>允许答题次数</label>
                      <input
                        style="width: 400px"
                        v-model="item.allowCount"
                        type="text"
                        class="form-control"
                        maxlength="30"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>每日允许答题次数</label>
                      <input
                        style="width: 400px"
                        v-model="item.dailyCount"
                        type="text"
                        class="form-control"
                        maxlength="30"
                      />
                    </div>
                  </div>
                </div>
                <!-- 关联媒体号 -->
                <!-- <div class="row">
                  <div class="">
                    <div class="mb-3">
                      <label>媒体号</label>
                      <div class="dsply-fix" style="align-items: center">
                        <div
                          class="select-current-media m-r-20"
                          v-if="currentMediaId.name"
                        >
                          <img
                            v-if="currentMediaId.avatar"
                            :src="`${currentMediaId.avatar}`"
                            alt
                          />
                          <img
                            v-if="!currentMediaId.avatar"
                            src="@/assets/images/default_cover_1_1.png"
                            alt=""
                          />
                          <span>{{ currentMediaId.name }}</span>
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-primary"
                          @click="selectMediaId()"
                        >
                          <i
                            class="bx bx-search-alt font-size-12 align-middle me-2"
                          ></i>
                          选择
                        </button>
                        <button
                          v-if="currentMediaId.name"
                          style="margin-left: 10px"
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="removeMediaId()"
                        >
                          删除
                        </button>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- 有效时间 -->
                <div class="row">
                  <div class="col-md-5">
                    <div class="mb-3">
                      <label>有效时间 <span style="color: red">*</span></label>
                      <div>
                        <el-date-picker
                          :disabled="longTime"
                          style="margin-right: 20px"
                          @change="checkTimer"
                          v-model="timerValue"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          type="datetimerange"
                          :picker-options="pickerOptions"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          align="right"
                        >
                        </el-date-picker>
                        <el-checkbox @change="checkLongTime" v-model="longTime"
                          >长期有效</el-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 题前设置 -->
                <div class="row" style="margin-top: 10px; margin-bottom: 10px">
                  <div class="col-md-5">
                    <div class="mb-3">
                      <div class="flex mb-3">
                        <span> 开启答前设置 </span>
                        <el-switch
                          style="margin-left: 10px"
                          active-color="#13ce66"
                          inactive-color="#ccc"
                          v-model="beforeSwitch"
                        >
                        </el-switch>
                      </div>
                      <span v-if="beforeSwitch">
                        <div style="margin: 20px 0">
                          <el-checkbox
                            style="margin-right: 10px; width: 150px"
                            v-model="beforeMedia"
                          >
                            关联关注媒体号</el-checkbox
                          >
                          <div
                            class="select-current-media m-r-20"
                            v-if="currentMedia.name"
                          >
                            <img
                              v-if="currentMedia.avatar"
                              :src="`${currentMedia.avatar}`"
                              alt
                            />
                            <img
                              v-if="!currentMedia.avatar"
                              src="@/assets/images/default_cover_1_1.png"
                              alt=""
                            />
                            <span>{{ currentMedia.name }}</span>
                          </div>
                          <el-button
                            @click="selectMedia()"
                            style="width: 95px"
                            size="small"
                            round
                            >选择</el-button
                          >
                        </div>
                        <div style="margin: 20px 0">
                          <el-checkbox
                            style="margin-right: 10px; width: 150px"
                            v-model="beforeCircle"
                          >
                            关联关注圈子</el-checkbox
                          >
                          <div
                            class="select-current-media m-r-20"
                            v-if="currentCircle.name"
                          >
                            <img
                              v-if="currentCircle.cover"
                              :src="`${currentCircle.cover}`"
                              alt
                            />
                            <img
                              v-if="!currentCircle.cover"
                              src="@/assets/images/default_cover_1_1.png"
                              alt=""
                            />
                            <span>{{ currentCircle.name }}</span>
                          </div>
                          <el-button
                            @click="openCircle"
                            style="width: 95px"
                            size="small"
                            round
                            >选择</el-button
                          >
                        </div>
                        <div style="margin: 20px 0">
                          <el-checkbox
                            style="margin-right: 10px; width: 150px"
                            v-model="friendsValue"
                            >邀请好友注册
                          </el-checkbox>
                          <el-input
                            v-model="item.inviteUserNum"
                            style="width: 95px"
                          ></el-input
                          >&emsp;人
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- 开启答题提示 -->
                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <el-checkbox v-model="item.openTip">
                        开启答题提示</el-checkbox
                      >
                    </div>
                  </div>
                </div>
                <!-- 开启错题解析 -->
                <div class="row" style="margin-bottom: 20px">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <div style="display: flex; align-items: center">
                        <el-checkbox
                          style="margin-right: 20px"
                          v-model="item.openAnalysis"
                        >
                          开启错题解析</el-checkbox
                        >
                        <el-radio-group
                          v-if="item.openAnalysis == true"
                          v-model="item.analysisType"
                        >
                          <el-radio :label="0">每题错题解析</el-radio>
                          <el-radio :label="1">全卷错题解析</el-radio>
                        </el-radio-group>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>问答设置</label>
                      <div>
                        <el-checkbox v-model="canSkip"
                          >是否允许跳过题目</el-checkbox
                        >
                        <el-checkbox v-model="canBack"
                          >是否允许回看题目</el-checkbox
                        >
                        <el-checkbox v-model="canModify" v-if="canBack"
                          >是否允许修改答案</el-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="row">
                  <div class="col-md-7" style="display: flex">
                    <div class="mb-3">
                      <label>是否允许回看题目</label>
                      <div>
                        <el-radio v-model="item.allowBack" :label="0"
                          >不允许</el-radio
                        >
                        <el-radio v-model="item.allowBack" :label="1"
                          >允许</el-radio
                        >
                      </div>
                    </div>
                    <div
                      class="mb-3"
                      style="margin-left: 50px"
                      v-if="item.allowBack"
                    >
                      <label>是否允许修改答案</label>
                      <div>
                        <el-radio v-model="item.allowModify" :label="0"
                          >不允许</el-radio
                        >
                        <el-radio v-model="item.allowModify" :label="1"
                          >允许</el-radio
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>是否允许跳过题目</label>
                      <div>
                        <el-radio v-model="item.allowSkip" :label="0"
                          >不允许</el-radio
                        >
                        <el-radio v-model="item.allowSkip" :label="1"
                          >允许</el-radio
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 访问限制 -->
                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>访问限制</label>
                      <div>
                        <el-radio
                          @input="checkAcc"
                          v-model="item.openVerify"
                          :label="false"
                          >关闭</el-radio
                        >
                        <el-radio v-model="item.openVerify" :label="true"
                          >开启</el-radio
                        >
                        <span>
                          <span v-show="item.openVerify" class="m-r-10">
                            访问密码
                          </span>
                          <el-form
                            style="
                              display: inline-block;
                              position: absolute;
                              top: 25%;
                            "
                            :model="item"
                            ref="numberValidateForm"
                          >
                            <el-form-item
                              prop="password"
                              :rules="[
                                { required: true, message: '密码不能为空' },
                                {
                                  min: 6,
                                  message: '密码最少为6位',
                                  trigger: 'blur',
                                },
                              ]"
                            >
                              <el-input
                                class="input-h-30"
                                v-show="item.openVerify"
                                style="width: 126px"
                                v-model="item.password"
                                oninput="value=value.replace(/[^\d]/g,'')"
                                placeholder="请输入6位数字"
                                maxlength="6"
                                clearable
                              >
                              </el-input>
                            </el-form-item>
                          </el-form>
                          <!-- <el-form-item label="年龄" prop="AccPassword">
                            <el-input
                              v-model.number="item.AccPassword"
                              type="number"
                              placeholder="请输入"
                            />
                          </el-form-item> -->
                          <!-- <el-input
                            v-show="item.accState == '1'"
                            type="number"
                            class="input-h-30"
                            show-password
                            v-model.number="item.AccPassword"
                            style="width: 126px; position: absolute; top: 25%"
                            maxlength="6"
                          ></el-input> -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 参与用户设置 -->
                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>参与用户设置</label>
                      <div>
                        <el-radio v-model="item.userType" label="0"
                          >全部用户</el-radio
                        >
                        <el-radio v-model="item.userType" label="1"
                          >指定用户
                        </el-radio>
                        <el-button
                          @click="userCheck"
                          style="position: absolute; top: 25px"
                          v-show="item.userType == 1"
                          size="mini"
                          type="primary"
                          round
                          >用户列表</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 状态 -->
                <div class="row">
                  <div class="col-md-7">
                    <div class="mb-3">
                      <label>状态</label>
                      <div>
                        <el-radio v-model="item.state" label="1">启用</el-radio>
                        <el-radio v-model="item.state" label="0">禁用</el-radio>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>

            <div class="row submit-bar" style="padding-top:15px">
              <div class="col-md-12">
                <!-- <div class="last-time pull-left">由 用户名 编辑于 2021-09-12 12:11:22</div> -->
                <div class="bar-handle" style="margin-bottom:15px">
                  <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    取消
                  </button>
                  <div>
                    <button
                      v-if="!index_id"
                      @click="submitAdd()"
                      class="btn-sm btn btn-primary"
                      type="button"
                    >
                      <span> 创建 </span>
                    </button>
                    <button
                      v-if="index_id"
                      @click="submitAdd()"
                      class="btn-sm btn btn-primary"
                      type="button"
                    >
                      <span> 保存 </span>
                    </button>
                  </div>

                  <!-- <button
                    v-if="index_id && item.verifyState != 3"
                    @click="submitReview()"
                    class="btn-sm btn btn-warning"
                    type="button"
                  >
                    保存并提交审核
                  </button>

                  <button
                    @click="batchRevert()"
                    v-if="index_id && item.verifyState == 3"
                    class="btn-sm btn btn-warning"
                    type="button"
                  >
                    撤销审核
                  </button>

                  <button
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    保存
                  </button> -->
                </div>
                <!-- <div class="bar-handle" v-if="allModify">
                  <button class="btn-sm btn btn-outline-dark" type="button" @click="goBack()">返回</button>
                  <button @click="batchRevert()" class="btn-sm btn btn-warning" type="button">撤销审核</button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <media-dialog @pageCallback="pageCallback" ref="media"></media-dialog>
    <addCircle @pageCallback="pageCallback" ref="add"></addCircle>
    <el-dialog title="用户列表" :visible.sync="userVisible" width="30%">
      <div
        class="flex"
        style="margin-bottom: 10px; justify-content: space-between"
      >
        <div @click="addUser">+新建</div>
        <div @click="clearUser" style="color: #999999">清空</div>
      </div>
      <div>
        <el-input
          @input="checkPhoneNumber"
          :disabled="userFlag"
          class="usList"
          type="textarea"
          autosize
          placeholder="请输入用户手机号，一行一条"
          v-model="item.targetUser"
          resize="none"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="userVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="userVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import question from "@/server/api/question";
import imageUpload from "../../../../components/imageUpload";
import mediaDialog from "@/components/choseMedia/mediaDialog.vue";
import addCircle from "./addCircle.vue";
export default {
  components: {
    imageUpload,
    mediaDialog,
    addCircle,
  },

  data() {
    return {
      userFlag: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      item: {
        title: "",
        createdAt: "",
        showState: "1",
        cover: "",
        time: "",
        allowCount: null,
        dailyCount: null,
        state: "1",
        relationMedia: 0, //关联媒体号id
        relationCircle: 0, //关联圈子id
        inviteUserNum: null, //邀请用户数
        startImage: "",
        backgroundImage: "",
        endImage: "",
        subjectColor: "",
        auxiliaryColor: "",
        userType: "0", //参与用户设置
        targetUser: "",
        mediaId: 0,
        password: "", //访问密码
        openVerify: false,
        allowSkip: 0, //跳过题目
        allowBack: 0, //题目返回
        allowModify: 0, //允许修改
      },
      index_id: "",
      timerValue: [],
      longTime: false,
      qaMinutes: null,
      qaSeconds: null,
      currentMedia: {},
      currentCircle: {},
      beforeSwitch: false,
      beforeMedia: false,
      beforeCircle: false,
      friendsValue: false,
      beforeJX: false,
      parsingValue: 1,
      colorArr: ["monochrome"],
      userVisible: false,
      currentMediaId: {},
    };
  },

  mounted() {
    // 获取详情
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
      this.fetch();
    }
  },

  methods: {
    checkAcc() {
      this.$refs["numberValidateForm"].clearValidate();
    },
    checkPhoneNumber() {
      let value = this.item.targetUser;
      let allLine = value.split("\n");
      let lastLine = allLine.pop();
      if (lastLine.length >= 11) {
        lastLine = lastLine.substr(0, 11) + "\n" + lastLine.substr(11);
        allLine.push(lastLine);
        this.item.targetUser = allLine.join("\n");
      }
    },
    selectMediaId() {
      let userId = this.item.mediaId ? this.item.mediaId : "";

      this.$refs.media.showModel(userId, "getMediaId");
    },
    removeMediaId() {
      this.item.mediaId = 0;
      this.currentMediaId = {};
    },
    clearUser() {
      this.item.targetUser = "";
    },
    addUser() {
      this.userFlag = false;
    },
    userCheck() {
      this.userVisible = true;
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code == "mediaId") {
        this.item.mediaId = obj.item.id;
        this.currentMediaId = obj.item;
      }
      if (obj.code == "media") {
        this.item.relationMedia = obj.item.id;
        this.currentMedia = obj.item;
      }
      if (obj.code == "circle") {
        this.item.relationCircle = obj.item.id;
        this.currentCircle = obj.item;
      }
    },

    tableParValueChange(row) {
      if (row.parValue === "") {
        row.error = "不能为空";
      } else if (row.parValue < 1) {
        row.error = "优惠面额最小为1";
      } else if (row.parValue > row.salePrice) {
        row.error = "不能大于" + row.salePrice;
      } else {
        row.error = "";
      }
    },
    qaMinutesChange(val, max) {
      this.$nextTick(() => {
        if (val == "") {
          // Vue.swal("时间不能为空");
          this.qaMinutes = 0;
          return;
        }
        this.qaMinutes = Math.min(parseInt(val), max);
      });
    },
    qaSecondsChange(val, max) {
      this.$nextTick(() => {
        if (val == "") {
          // Vue.swal("时间不能为空");
          this.qaSeconds = 0;
          return;
        }
        this.qaSeconds = Math.min(parseInt(val), max);
      });
    },
    //秒转 分 秒
    formatSeconds(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor(result / 60) < 10
          ? Math.floor(result / 60)
          : Math.floor(result / 60);
      let s =
        Math.floor(result % 60) < 10
          ? +Math.floor(result % 60)
          : Math.floor(result % 60);

      let res = { min: m, s: s };
      return res;
    },
    fetch() {
      let params = { id: this.index_id };
      question.detail(params).then((resp) => {
        if (resp.code == 0) {
          this.item = resp.data;
          this.item.allowBack = this.item.allowBack ? 1 : 0;
          this.item.allowModify = this.item.allowModify ? 1 : 0;
          this.item.allowSkip = this.item.allowSkip ? 1 : 0;
          this.$refs.coverImg.setImageUrl(this.item.cover);
          this.$refs.welComeImg.setImageUrl(this.item.startImage);
          this.$refs.BgImg.setImageUrl(this.item.backgroundImage);
          this.$refs.endImg.setImageUrl(this.item.endImage);

          this.qaMinutes = this.formatSeconds(this.item.time).min;
          this.qaSeconds = this.formatSeconds(this.item.time).s;
          if (this.item.endTime == "2033-01-01 00:00:01") {
            this.longTime = true;
          }
          this.timerValue = [this.item.startTime, this.item.endTime];
          this.item.state = this.item.state + "";
          this.item.userType = this.item.userType + "";
          this.item.targetUser = this.item.targetUser.replaceAll(",", "\n");

          if (
            this.item.relationMedia != 0 ||
            this.item.relationCircle != 0 ||
            this.item.inviteUserNum != 0
          ) {
            this.beforeSwitch = true;
          } else {
            this.beforeSwitch = false;
          }
          if (this.item.mediaId != 0) {
            this.currentMediaId.name = this.item.bindMediaName;
            this.currentMediaId.avatar = this.item.bindMediaCover;
          }

          if (this.item.relationMedia != 0) {
            this.beforeMedia = true;
            this.currentMedia.name = this.item.mediaName;
            this.currentMedia.avatar = this.item.mediaCover;
          }

          if (this.item.relationCircle != 0) {
            this.currentCircle.name = this.item.circleName;
            this.currentCircle.cover = this.item.circleCover;
            this.beforeCircle = true;
          }

          if (this.item.inviteUserNum != 0) {
            this.friendsValue = true;
          } else {
            this.friendsValue = false;
          }

          if (this.item.openTip == 1) {
            this.item.openTip = true;
          } else {
            this.item.openTip = false;
          }

          if (this.item.openAnalysis == 1) {
            this.item.openAnalysis = true;
          } else {
            this.item.openAnalysis = false;
          }
          // if (this.item.openAnalysis || this.item.analysisType) {
          //   this.beforeJX = true;
          //   if (this.item.openAnalysis == 1) {
          //     this.parsingValue = 1;
          //   }
          //   if (this.item.analysisType == 1) {
          //     this.parsingValue = 2;
          //   }
          // }
        } else {
          Vue.swal(resp.msg);
        }
      });
    },
    //保存
    // submitPreserve() {
    //   let params = {};

    //   if (this.index_id) {
    //     params.id = this.index_id;
    //   }

    //   if (this.item.title) {
    //     params.title = this.item.title;
    //   } else {
    //     Vue.swal("请输入标题");
    //     return;
    //   }

    //   params.cover = this.$refs.coverImg.getImageUrl();
    //   if (!params.cover) {
    //     Vue.swal("请上传封面图");
    //     return;
    //   }

    //   params.endImage = this.$refs.endImg.getImageUrl();
    //   console.log(params.endImage);
    //   if (!params.endImage) {
    //     Vue.swal("请上传结束图");
    //     return;
    //   }
    //   if (!this.qaMinutes && !this.qaSeconds) {
    //     Vue.swal("请输入答题时间");
    //     return;
    //   } else {
    //     params.qaMinutes = this.qaMinutes;
    //     params.qaSeconds = this.qaSeconds;
    //   }

    //   if (this.item.allowCount) {
    //     params.allowCount = this.item.allowCount;
    //   } else {
    //     Vue.swal("请输入允许答题次数");
    //     return;
    //   }
    //   if (this.item.dailyCount) {
    //     params.dailyCount = this.item.dailyCount;
    //   } else {
    //     Vue.swal("请输入每日允许答题次数");
    //     return;
    //   }
    //   if (this.longTime) {
    //     params.startTime = this.dateFormat();
    //     params.endTime = "2033-01-01 00:00:01";
    //   } else {
    //     if (!this.timerValue) {
    //       Vue.swal("请选择有效时间");
    //       return;
    //     } else {
    //       params.startTime = this.timerValue[0];
    //       params.endTime = this.timerValue[1];
    //     }
    //   }

    //   if (this.beforeMedia) {
    //     if (this.item.relationMedia) {
    //       params.relationMedia = this.item.relationMedia;
    //     } else {
    //       params.relationMedia = 0;
    //     }
    //   } else {
    //     params.relationMedia = 0;
    //   }
    //   if (this.beforeCircle) {
    //     if (this.item.relationCircle) {
    //       params.relationCircle = this.item.relationCircle;
    //     } else {
    //       params.relationCircle = 0;
    //     }
    //   } else {
    //     params.relationCircle = 0;
    //   }
    //   if (this.friendsValue) {
    //     params.inviteUserNum = Number(this.item.inviteUserNum);
    //   } else {
    //     params.inviteUserNum = 0;
    //   }
    //   if (this.item.openTip) {
    //     params.openTip = 1;
    //   } else {
    //     params.openTip = 0;
    //   }

    //   if (this.item.openAnalysis) {
    //     params.openAnalysis = 1;
    //     params.analysisType = this.item.analysisType;
    //   } else {
    //     params.openAnalysis = 0;
    //     params.analysisType = 0;
    //   }
    //   if (!this.beforeSwitch) {
    //     params.relationMedia = 0;
    //     params.relationCircle = 0;
    //     params.inviteUserNum = 0;
    //   }
    //   // if (this.beforeJX) {
    //   //   if (this.parsingValue == 1) {
    //   //     params.openAnalysis = 1;
    //   //     params.analysisType = 0;
    //   //   } else if (this.parsingValue == 2) {
    //   //     params.analysisType = 1;
    //   //     params.openAnalysis = 0;
    //   //   } else {
    //   //     params.openAnalysis = 0;
    //   //     params.analysisType = 0;
    //   //   }
    //   // } else {
    //   //   params.openAnalysis = 0;
    //   //   params.analysisType = 0;
    //   // }

    //   params.state = this.item.state;

    //   params.subjectColor = this.item.subjectColor;
    //   params.auxiliaryColor = this.item.auxiliaryColor;

    //   params.startImage = this.$refs.welComeImg.getImageUrl();
    //   params.backgroundImage = this.$refs.BgImg.getImageUrl();
    //   params.endImage = this.$refs.endImg.getImageUrl();

    //   let sendParm = {
    //     id: params.id,
    //     title: params.title,
    //     cover: params.cover,
    //     startTime: params.startTime,
    //     endTime: params.endTime,
    //     state: Number(params.state),
    //     time: Number(params.qaMinutes * 60 + params.qaSeconds),
    //     allowCount: params.allowCount,
    //     dailyCount: params.dailyCount,

    //     relationMedia: params.relationMedia, //关联媒体号id
    //     relationCircle: params.relationCircle, //关联圈子id
    //     inviteUserNum: params.inviteUserNum, //邀请用户数
    //     openTip: params.openTip, //params.relationMedia-关闭提示,1-开启提示
    //     openAnalysis: params.openAnalysis, //params.relationMedia-关闭解析,1开启解析
    //     analysisType: params.analysisType, //params.relationMedia-题目解析,1-全卷解析
    //     startImage: params.startImage,
    //     backgroundImage: params.backgroundImage,
    //     endImage: params.endImage,
    //     subjectColor: params.subjectColor,
    //     auxiliaryColor: params.auxiliaryColor,
    //   };
    //   question.base(sendParm).then((resp) => {
    //     if (resp.code == 0) {
    //       Vue.swal({
    //         icon: "success",
    //         title: "保存成功！",
    //         showConfirmButton: false,
    //         timer: 1000,
    //       });
    //       this.goBack();
    //     } else {
    //       Vue.swal({
    //         icon: "error",
    //         title: resp.msg,
    //         showConfirmButton: false,
    //         timer: 1500,
    //       });
    //     }
    //   });
    // },
    //创建 || 保存
    submitAdd() {
      let params = {};

      if (this.index_id) {
        params.id = this.index_id;
      }
      if (this.item.title) {
        params.title = this.item.title;
      } else {
        Vue.swal("问答名称");
        return;
      }
      params.cover = this.$refs.coverImg.getImageUrl();
      if (!params.cover) {
        Vue.swal("请上传封面图");
        return;
      }
      params.endImage = this.$refs.endImg.getImageUrl();
      if (!params.endImage) {
        Vue.swal("请上传结束图");
        return;
      }
      // console.log(this.qaSeconds);
      // if (!this.qaSeconds) {
      //   Vue.swal("请选择秒数");
      //   return;
      // }

      if (!this.qaMinutes && !this.qaSeconds) {
        Vue.swal("请输入答题时间");
        return;
      } else {
        params.qaMinutes = this.qaMinutes;
        params.qaSeconds = this.qaSeconds;
      }
      // if (this.qaMinutes) {
      //   params.qaMinutes = this.qaMinutes;
      // } else {
      //   Vue.swal("请输入时间");
      //   return;
      // }
      // if (this.qaSeconds) {
      //   params.qaSeconds = this.qaSeconds;
      // } else {
      //   Vue.swal("请输入时间");
      //   return;
      // }
      if (this.item.allowCount) {
        params.allowCount = this.item.allowCount;
      } else {
        // Vue.swal("请输入答题次数");
        // return;
      }
      if (this.item.dailyCount) {
        params.dailyCount = this.item.dailyCount;
      } else {
        // Vue.swal("请输入每日答题次数");
        // return;
      }

      //题目返回
      params.allowBack = this.item.allowBack;
      if (params.allowBack) {
        //修改题目
        params.allowModify = this.item.allowModify;
      } else {
        params.allowModify = 0;
      }
      //跳过题目
      params.allowSkip = this.item.allowSkip;

      params.cover = this.$refs.coverImg.getImageUrl();
      if (this.longTime) {
        params.startTime = this.dateFormat();
        params.endTime = "2033-01-01 00:00:01";
      } else {
        if (this.timerValue.length === 0) {
          Vue.swal("请选择有效时间");
          return;
        } else {
          params.startTime = this.timerValue[0];
          params.endTime = this.timerValue[1];
        }
      }

      if (this.beforeMedia) {
        if (this.item.relationMedia) {
          params.relationMedia = this.item.relationMedia;
        } else {
          params.relationMedia = 0;
        }
      } else {
        params.relationMedia = 0;
      }
      if (this.beforeCircle) {
        if (this.item.relationCircle) {
          params.relationCircle = this.item.relationCircle;
        } else {
          params.relationCircle = 0;
        }
      } else {
        params.relationCircle = 0;
      }
      if (this.friendsValue) {
        params.inviteUserNum = Number(this.item.inviteUserNum);
      } else {
        params.inviteUserNum = 0;
      }
      if (this.item.openTip) {
        params.openTip = 1;
      } else {
        params.openTip = 0;
      }
      if (this.item.openAnalysis) {
        params.openAnalysis = 1;
        params.analysisType = this.item.analysisType;
      } else {
        params.openAnalysis = 0;
        params.analysisType = 0;
      }

      // if (this.beforeJX) {
      //   if (this.parsingValue == 1) {
      //     params.openAnalysis = 1;
      //     params.analysisType = 0;
      //   } else if (this.parsingValue == 2) {
      //     params.analysisType = 1;
      //     params.openAnalysis = 0;
      //   } else {
      //     params.openAnalysis = 0;
      //     params.analysisType = 0;
      //   }
      // } else {
      //   params.openAnalysis = 0;
      //   params.analysisType = 0;
      // }
      params.showState = this.item.state;
      params.subjectColor = this.item.subjectColor;
      params.auxiliaryColor = this.item.auxiliaryColor;

      params.startImage = this.$refs.welComeImg.getImageUrl();
      params.backgroundImage = this.$refs.BgImg.getImageUrl();
      params.endImage = this.$refs.endImg.getImageUrl();

      if (this.item.userType == "0") {
        this.item.targetUser = "";
      }
      if (this.item.openVerify && !this.item.password) {
        Vue.swal("请输入访问密码");
        return;
      }
      if (this.item.openVerify) {
        let Flag = true;
        this.$refs["numberValidateForm"].validate((valid) => {
          if (valid) {
          } else {
            Flag = false;
            return false;
          }
        });
        if (!Flag) {
          return;
        }
      }

      let sendParm = {
        title: params.title,
        cover: params.cover,
        startTime: params.startTime,
        endTime: params.endTime,
        allowCount: params.allowCount ? Number(params.allowCount) : "",
        dailyCount: params.dailyCount ? Number(params.dailyCount) : "",
        state: Number(params.showState),
        time: Number(params.qaMinutes * 60 + params.qaSeconds),
        relationMedia: params.relationMedia, //关联媒体号id
        relationCircle: params.relationCircle, //关联圈子id
        inviteUserNum: params.inviteUserNum, //邀请用户数
        openTip: params.openTip, //params.relationMedia-关闭提示,1-开启提示
        openAnalysis: params.openAnalysis, //params.relationMedia-关闭解析,1开启解析
        analysisType: params.analysisType, //params.relationMedia-题目解析,1-全卷解析
        startImage: params.startImage,
        backgroundImage: params.backgroundImage,
        endImage: params.endImage,
        subjectColor: params.subjectColor,
        auxiliaryColor: params.auxiliaryColor,
        userType: Number(this.item.userType),
        allowBack: params.allowBack,
        allowModify: params.allowModify,
        allowSkip: params.allowSkip,
        targetUser: JSON.parse(JSON.stringify(this.item.targetUser)).replaceAll(
          "\n",
          ","
        ),
        mediaId: JSON.parse(localStorage.chosedMedia).id, // this.item.mediaId,
        openVerify: this.item.openVerify,
        password: this.item.password,
      };
      if (this.index_id) {
        sendParm.id = this.index_id;
        console.log("保存参数", sendParm);
        question.base(sendParm).then((resp) => {
          if (resp.code == 0) {
            this.addCache("question-edit", {
              id: this.index_id,
            });
            Vue.swal({
              icon: "success",
              title: "保存成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.goBack();
          } else {
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      } else {
        console.log("保存参数", sendParm);
        question.add(sendParm).then((resp) => {
          if (resp.code == 0) {
            this.addCache("question-edit", {
              changed: true,
            });
            Vue.swal({
              icon: "success",
              title: "创建成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.goBack();
          } else {
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }
    },
    //获取当前时间
    dateFormat() {
      var date = new Date();
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },

    goBack() {
      this.$router.go(-1);
    },
    //修改时间
    checkTimer() {
      // this.item.startTime = this.timerValue[0];
      // this.item.endTime = this.timerValue[1];
    },
    checkLongTime() {
      // this.timerValue[0] = this.dateFormat();
      // this.timerValue[1] = "2033-01-01 00:00:01";
    },
    //打开媒体号
    selectMedia() {
      let userId = this.item.relationMedia ? this.item.relationMedia : "";
      this.$refs.media.showModel(userId, "getMedia");
    },
    //打开圈子
    openCircle() {
      this.$refs.add.showModel();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.input-h-30 {
  .el-input__inner {
    height: 35px !important;
  }
}
.usList {
  .el-textarea__inner {
    min-height: 350px !important;
    height: 350px !important;
    overflow: auto;
  }
}
</style>
<style scoped>
.submit-bar {
  padding: 10px;
}
.card {
  margin-bottom: 0px;
}
.select-current-media {
  display: inline-block;
  width: auto;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  position: relative;
  padding-left: 3.2rem;
}

.select-current-media img {
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  left: 0.75rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
